import { IonInput as IonicIonInput, IonIcon } from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Title = styled.div`
  font-size: 18px;
  line-height: 18px;
  font-weight: 500;
  margin-bottom: 16px;
`

export const CheckboxTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`

export const InputWrapper = styled.div`
  position: relative;
`

export const InputIcon = styled(IonIcon)`
  position: absolute;
  top: 16px;
  right: 8px;
  z-index: 2;
`

export const IonInput = styled(IonicIonInput)`
  && {
    --background: ${myPalette.white.main};
    --border-color: ${myPalette.blue.lightSteelBlue};
    --border-width: 1px !important;
    --padding-start: 16px;
    --border-radius: 6px;
    min-height: 48px;

    &.has-value,
    &.has-focus {
      .label-text-wrapper {
        transform: translateY(-32%) scale(0.75) !important;
      }
    }

    .label-text-wrapper {
      color: ${myPalette.blue.lightSteelBlue} !important;
      transform: translateY(80%) !important;
    }

    input {
      margin-right: 16px !important;
    }
  }
`

export const CheckBoxWrapper = styled(DrawerWrapper)`
  margin-bottom: 46px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 0 16px;
  gap: 8px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 16px;
  z-index: 2;
`
